// Core
import React from 'react';
import { NavLink } from 'react-router-dom';
import { Box, Button, Flex, Text, Grid, Divider, Image, useColorMode, useColorModeValue } from '@chakra-ui/react';

// Assets
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import prizes from 'assets/img/prizes.png';
import galleryBgLeft from 'assets/img/details/gallery-bg-left.png';
import galleryBgRight from 'assets/img/details/gallery-bg-right.png';
import allPrizes from 'assets/img/all-prizes.png';
import animatedHome from 'assets/img/login/home.png';
import animatedCar1 from 'assets/img/login/car1.png';
import animatedCar2 from 'assets/img/login/car2.png';
import animatedCrystal from 'assets/img/login/crystal.png';
import animatedTicket from 'assets/img/login/ticket.png';
import animatedBox from 'assets/img/login/box.png';

// Components
import { StarsIcon } from '../../components/Icons/Icons';
import WhatIs from './components/WhatIs';
import Gallery from 'components/Sliders/Gallery';
import Partners from './components/Partners';
import GivenCard from './components/GivenCard';
import Li from 'components/Lists/List';
import { MapIcon } from 'components/Icons/Icons';

const BecomeAPartner = () => {
  const bgDividerDark = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #9EDFFF 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
  const bgDividerWhite = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #38A9E1 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
  const bgDivider = useColorModeValue(bgDividerWhite, bgDividerDark);

  const galleryShadow = useColorModeValue('#E0EAFF', '#00071C');

  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  return (
    <>
      <Box 
        position="relative" 
        pb="100px" 
        w={{ base: '100%' }}
        left={{ base: '0' }}
        float="unset"
        alignItems="center"
        justifyContent="center"
        m="0px auto"
        maxW="1084px">
        { isDark && <Box className="abstract-grad animation-scale-grad" mt={{base: '170px', md: '50px'}} />}
        { isDark && <Box className="abstract-grad animation-scale-grad" left="60%" transform="scale(1.7)" bottom="50%" />}
        <Image 
          src={prizes} alt='prizes' 
          right={{base: 'unset', sm: '-80px', md: '-125px', lg: '-163px'}}
          top={{base: '140px', sm: '-54px', md: '-84px'}}
          maxW={{base: '460px', sm: '573px', md: '673px', lg: '825px'}}
          left={{base: '50%', sm: 'unset'}}
          transform={{base: 'translate(-50%, 0px)', sm: 'unset'}}
          w={{base: '460px', sm: '100%'}}
          position="absolute" 
          zIndex="-1"/>

        <Box 
          display={{base: 'block', md: 'none'}}
          top="-60px"
          bg={ isDark ? '#00071C' : '#dfe9fd'}  zIndex="-1" filter="blur(60px)" opacity="0.5" borderRadius="100%" w={{base: '100%', sm: '70%', md: 'none'}} h="290px" position="absolute" />

        <Text as="h1" variant="header" fontSize={{base: '36px', md: '64px', lg: '72px'}} mt={{base: '45px', md: '88px', lg: '133px'}}>
          Partner with <br />
          <Text as="span" 
            variant="header-gradient" 
            lineHeight={{base: '64px', lg: '97px'}}
            fontSize={{base: '72px', md: '96px', lg: '128px'}}
            >LMCT+</Text>
          <Flex gap="24px" mt="12px" alignItems="center" gap={{base: '8px' ,sm: '24px'}}>
            <StarsIcon fontSize={{base: '24px', md: '42px'}} />
            <Box
               borderRadius={{base: '8px', sm: '16px'}}
               p="3px 24px"
               as="span"
               background="white">
              <Text variant="header-gradient" fontSize={{base: '36px', md: '64px', lg: '72px'}}>& LUXE+</Text>
            </Box>
          </Flex>
        </Text>

        <Box mt={{base: '290px', sm: '40px'}}>
          <NavLink to="/partner-with-us">
            <Button variant="button-lg" maxW={{base: '100%', sm: '280px'}}>
              Become A Partner
            </Button>
          </NavLink>
        </Box>
      </Box>

      <Text mt="-26px" mb="32px" as="h2" variant="header" fontSize="32px" fontStyle="normal">
        What is{' '}
        <Text as="span" variant="header-gradient" fontSize="32px" fontStyle="normal">
          LMCT+
        </Text>{' '}
        &{' '}
        <Text as="span" variant="header-gradient" fontSize="32px" fontStyle="normal">
          LUXE+
        </Text>
        ?
      </Text>
      <WhatIs />

      <GivenCard />

      <Text as="h4" variant="header" mt={{base: '55px', sm: '71px'}} fontSize={{base: '24px', md: '32px'}} fontStyle="normal">The platform</Text>
      <Grid templateColumns={{ sm: '1fr', lg: '0.6fr 1fr' }} gap="10px" templateRows='1fr' mt="30px">
        <Box>
            { isDark && <Box className="abstract-grad" mt="50px" transform="scale(0.6)" />}

            <Flex gap="8px">
                 <Text variant="header" fontSize={{base: '48px', md: '64px'}} letterSpacing="0px">1 000 000</Text>
                 <Text variant="header-gradient" fontSize={{base: '48px', md: '64px'}} mt="3px">+</Text>
            </Flex>
            <Text variant="title-sm" fontSize="13px" textTransform="uppercase" mt="6px">people weekly that access our platform</Text>
        </Box>

        <Box>
            { isDark && <Box className="abstract-grad" mt="50px" transform="scale(0.6)" />}

            <Flex gap="8px">
                 <Text variant="header" fontSize={{base: '48px', md: '64px'}} letterSpacing="0px">$1 000 000</Text>
                 <Text variant="header-gradient" fontSize={{base: '48px', md: '64px'}} mt="3px">+</Text>
            </Flex>
            <Text variant="title-sm" fontSize="13px" textTransform="uppercase" mt="6px">returned to local Aussie businesses</Text>
        </Box>
      </Grid>
      <Grid templateColumns={{ sm: '1fr', lg: '0.8fr 1fr' }} gap="24px" templateRows='1fr' mt={{base: '32px', md: '54px'}}>
        <Box>
            <Text variant="header" fontSize={{base: '20px', md: '24px'}} fontStyle="normal" mb="-3px">This is where the magic happens</Text>
            <Li text="It’s simple, we have MILLIONS of people weekly that access our platform to utilize exclusive offers from businesses like you. They also get access to Australia’s original and best giveaways." />
            <Li text="We’ve also given back over $1,000,000 to local Aussie businesses. We`re running weekly promotional giveaways, which means engagement is high all year long. More engagement more traffic to your business." />
            <Text pt="32px" maxW={{sm: '100%', md: '85%'}} letterSpacing="0" variant="header-gradient" fontSize="16px" lineHeight="120%">As we`ve now not only expanded from cars to bikes and boats but we`ve now stepped into giving away homes to give Aussies a chance to win their dream house!</Text>
        </Box>

        <Box position="relative" display={{base: 'none', lg: 'block'}}>
          <Box 
            mt={{md: '80px', lg: '100px'}}
            position="relative" 
            h={{base: '70%', lg: '90%'}}
            left={{base: '-10%', lg: '-3%'}}
            transform={{base: 'scale(0.8)', lg: 'scale(1)'}}>
              <Box position="absolute" className="animation-prizes" bottom="10%" left="25%" w="400px" h="400px">
                { isDark && <Box w="400px" h="400px" position="absolute" bg="#099BFF" filter="blur(90px)" borderRadius="full" left="-10%" top="-10%" className="animation-prizes-gradient"/>}
                <Image src={animatedHome} alt="Home" w="325px" bottom="-4px" left="-2px" className="animation-prizes-home" zIndex="8" />
                <Image src={animatedCar1} alt="Car" w="205px" bottom="8px" left="-82px" transform="rotate(0deg)" className="animation-prizes-car1" zIndex="7" />
                <Image src={animatedCar2} alt="Car" w="205px" bottom="-1px" right="-16px" transform="rotate(0deg)" className="animation-prizes-car2" zIndex="7" />
                <Image src={animatedCrystal} alt="Crystal" w="100px" bottom="119px" left="-66px" transform="rotate(-22deg)" zIndex="6" className="animation-prizes-crystal1" />
                <Image src={animatedCrystal} alt="Crystal" w="145px" bottom="140px" left="-30px" transform="rotate(19deg)" zIndex="6" className="animation-prizes-crystal2" />
                <Image src={animatedTicket} alt="Ticket" w="110px" bottom="136px" right="86px" transform="rotate(-44deg)" zIndex="5" className="animation-prizes-ticket1" />
                <Image src={animatedTicket} alt="Ticket" w="70px" bottom="141px" right="53px" transform="rotate(-119deg)" zIndex="5" className="animation-prizes-ticket2" />
                <Image src={animatedBox} alt="Box" w="300px" bottom="33px" left="-6px" transform="rotate(15deg) scale(1)" zIndex="1" className="animation-prizes-box" />
              </Box>
          </Box>
        </Box>
      </Grid>

      <Box mt={{base: '60px', md: '130px'}} textAlign="center" position="relative">
        <Flex display={{base: 'block', md: 'flex'}} gap="16px" justifyContent="center">
          <Box>
            <Text as="h4" variant="header-gradient" fontSize={{base: '36px', md: '40px', lg: '48px'}}>Famous Giveaway</Text>
            <Divider mt="3px" h="2px" borderWidth="0" w={{base: '50%', md: '100%'}} bg={bgDivider} mx="auto" />
          </Box>
          <Flex 
              display="inline-flex"
              gap="8px"
              mt={{base: '8px', md: '-8px'}}
              borderRadius={{base: '8px', md: '16px'}}
              p="3px 16px"
              background="white"
              alignItems="center">
              <StarsIcon fontSize="24px" />
              <Text as="h2" variant="header-gradient" fontSize={{base: '36px', md: '40px', lg: '48px'}}>Winners</Text>
          </Flex>
        </Flex>

        <Text m="20px auto 23px auto" maxW={{ sm: '100%', md: '50%'}}>
          Each and every giveaway has cash supplementary prizes that can <span style={{color: '#0497FD'}}>ONLY </span>
          be spent with our partners! With over 200 promotions to date,
          our supplementary prize winner can only spend their prize money
          <span style={{color: '#0497FD'}}> EXCLUSIVELY</span> with businesses like you!
        </Text>

        <Box position="absolute" zIndex="-1" w="100%" top="-50px" opacity={{base: '0.2', md: '1'}}>
          <Image src={galleryBgLeft} alt="Gallery" position="absolute" objectFit="contain" w="100%" h="760px" left="-30%" top="17px" />
          <Image src={galleryBgRight} alt="Gallery" position="absolute" objectFit="contain" w="100%" h="760px" left="unset" right="-30.5%" top="-9px" />
          <Box bg={galleryShadow} mt="180px" zIndex="1" filter="blur(150px)" borderRadius="100%" w="100%" h="390px" position="absolute" />
        </Box>
      </Box>
      <Gallery />

      <Text as="h4" variant="header" mt="90px" fontSize="32px" fontStyle="normal" pl="9px">Become a reliable partner</Text>
      <Partners />

      <Box mb={{base: '60px', md: '140px'}} />

    </>
  );
};

export default BecomeAPartner;